import { secondAxios } from "../../../../../../api/axios";

export const get5d = async (equipId) => {
  console.log("CALLING API IN GET5d");
  const response = await secondAxios.get(`/cost5d/${equipId}/rev/303/pv`);
  console.log("xxxxxxxxxxxxxxxxxxxxxxxx", { response });
  return response.data;
};
